'use client';

import { Box, VStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';

export function AuthenticateRenderer({
  data,
  maxHeight,
  error,
}: {
  data: unknown;
  maxHeight?: string;
  error?: string;
}) {
  const t = useTranslations('designSystem.chat.authenticate');
  const content = typeof data === 'string' ? data : JSON.stringify(data);

  if (!content && !error) return null;

  const match =
    !error &&
    content?.match(
      /^Authenticated credential (\S+) \(role: (.*?)\)(?: at ([^\n]+))?\.\n\nSecrets written to: ([^\n]+)(?:\n\n([\s\S]*))?$/,
    );

  if (!match) {
    return (
      <Box
        fontSize="xs"
        whiteSpace="pre-wrap"
        wordBreak="break-word"
        maxHeight={maxHeight}
        overflow="auto"
        color={error ? 'fg.error' : 'fg.muted'}
      >
        {error || content}
      </Box>
    );
  }

  const [, credentialId, role, authenticatedAt, filePath, instructions] = match;

  return (
    <VStack
      alignItems="stretch"
      gap={2}
      fontSize="xs"
      maxHeight={maxHeight}
      overflow="auto"
      wordBreak="break-word"
    >
      <Box color="fg.success">{t('success')}</Box>
      <Box>
        {t('credential')}:{' '}
        <Box as="span" fontFamily="mono">
          {credentialId}
        </Box>
      </Box>
      <Box>
        {t('role')}: {role}
      </Box>
      {authenticatedAt ? (
        <Box>
          {t('authenticatedAt')}: {authenticatedAt}
        </Box>
      ) : null}
      <Box>
        {t('secretsFile')}:{' '}
        <Box as="span" fontFamily="mono">
          {filePath}
        </Box>
      </Box>
      {instructions ? (
        <Box color="fg.muted" whiteSpace="pre-wrap">
          {instructions}
        </Box>
      ) : null}
    </VStack>
  );
}

